import { memo } from "react";

import { type TTailwindString, tw } from "classnames";

export type IconName =
  | "arrow"
  | "arrow-down"
  | "arrowhead"
  | "caret"
  | "checkmark"
  | "close"
  | "dropdown-arrow"
  | "exclamation-circle"
  | "facebook"
  | "flag-australia"
  | "flag-canada"
  | "flag-united-kingdom"
  | "flag-united-states"
  | "gift"
  | "instagram"
  | "loading-wheel"
  | "minus"
  | "pause"
  | "play"
  | "play-circle"
  | "plus"
  | "search"
  | "star-empty"
  | "star-full"
  | "star-half-full"
  | "swatch-jal-meokkesseumnida"
  | "swatch-noosh-e-joon"
  | "swatch-sahtein"
  | "tiktok"
  | "trash";

interface Props {
  className?: TTailwindString;
  name: IconName;
}

const IconBase = ({ className = tw("w-8", "h-8"), name }: Props) => {
  return (
    <svg
      aria-labelledby={`${name}-icon`}
      className={tw("pointer-events-none", className)}
      role="img"
    >
      <title id={`${name}-icon`}>{`${name} icon`}</title>
      <use xlinkHref={`#${name}`} />
    </svg>
  );
};

export const Icon = memo(IconBase);
